import type { FC, AnchorHTMLAttributes } from 'react';

import { AnchorContainer, RRLinkContainer } from './Link.styles';
import useWhiteLabelComponent from '../../hooks/useWhiteLabelComponent';


export interface LinkComponentProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target'> {
    to: string;
    colour?: string;
    openInNewTab?: boolean;
}
/** Link rendered in specified colour. Underline disappears on hover. */
const Link: FC<LinkComponentProps> = ({ to, colour, children, openInNewTab = false, ...props }) => {
    const { accentColour } = useWhiteLabelComponent() as { accentColour: string };

    const resolvedColour = colour || accentColour;

    if (to.charAt(0) === '/') {
        return (
            <RRLinkContainer to={to} $colour={resolvedColour} target={openInNewTab ? '_blank' : '_self'} {...props}>
                {children}
            </RRLinkContainer>
        );
    }

    return (
        <AnchorContainer href={to} $colour={resolvedColour} target={openInNewTab ? '_blank' : '_self'} {...props}>
            {children}
        </AnchorContainer>
    );
};

export default Link;
